<div class="appointment-message">
  <mat-icon class="appointment-message__icon">event</mat-icon>
  <div class="appointment-message__details">
    <span class="appointment-message__heading">{{ statusKey() | translate }}</span>
    @if (formattedStartTime(); as startTime) {
      <span class="appointment-message__time">{{ startTime }}</span>
    }
  </div>
</div>
